<app-header></app-header>
<app-sidebar
ativo="Agenda"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Agenda"
      Pagina="Agenda"
    ></app-breadcrumb>
    <div class="row">
        <div class="row" style="padding: 20px 20px 0px 20px;">
          <div class="col-md-8">
            <button class="btn btn-primary" style="cursor: pointer;" (click)="abrirModal()">Nova tarefa</button>
            <button class="btn btn-primary" style="cursor: pointer;margin-left: 20px" (click)="abrirModalAtendimento()">Novo lead</button>
          </div>
          <div class="col-md-4 text-right pull-right">
            <button (click)="diario=true;mensal=false;semanal=false;"
                    class="btn btn-primary"
                    [ngClass]="{'ativo': diario}"
                    style="margin-right: 15px">Diário</button>
            <button (click)="diario=false;mensal=false;semanal=true;"
                    class="btn btn-primary"
                    [ngClass]="{'ativo': semanal}"
                    style="margin-right: 15px; cursor: grab">Semanal</button>

            <button (click)="diario=false;mensal=true;semanal=false;"
                    class="btn btn-primary"
                    [ngClass]="{'ativo': mensal}" >Mensal</button>

          </div>
          <hr style="margin-top: 20px;">
        </div>
        <app-semanal *ngIf="semanal"></app-semanal>
        <app-diario *ngIf="diario"></app-diario>
        <app-calendario
          titulo="Agenda"
          *ngIf="mensal"></app-calendario>
        <app-novo-compromisso
          (atualizarListaPai)="atualizarLista()"
          (atualizarListaDiario)="atualizarListaDiario()"
          ></app-novo-compromisso>
    </div>
  </section>
</div>
<app-cadastro-novo-atendimento
  (atualizarLista)="atualizarLista()"
></app-cadastro-novo-atendimento>
